import CompanyAvailabilityEmployeeSearch from './CompanyAvailabilityEmployeeSearch';

export default CompanyAvailabilityEmployeeSearch;
